import { render, staticRenderFns } from "./BikyConfigBasic.vue?vue&type=template&id=5bf9ac0d&scoped=true&"
import script from "./BikyConfigBasic.vue?vue&type=script&lang=ts&"
export * from "./BikyConfigBasic.vue?vue&type=script&lang=ts&"
import style0 from "./BikyConfigBasic.vue?vue&type=style&index=0&id=5bf9ac0d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf9ac0d",
  null
  
)

export default component.exports